/**
 * Owner: Masa Bayu
 * File: errors.ts
 * Date:Time: 2026-09-19 15:48
 * Description: Typed errors for QX language identity validation (GL-01).
 */
export class QxLanguageError extends Error {
    code;
    constructor(code, message) {
        super(message);
        this.name = 'QxLanguageError';
        this.code = code;
    }
}
//# sourceMappingURL=errors.js.map